import { connect } from 'react-redux'
import { getCaptcha } from '../../redux/app/selectors'
import Captcha from './Captcha.jsx'
import { getLocale } from '../../redux/app/selectors'

const mapStateToProps = state => ({
    captcha: getCaptcha(state),
    locale: getLocale(state),
})

export const CaptchaContainer = connect(
    mapStateToProps,
)(Captcha)
